export default {
  root: {
    zIndex: '1301 !important',
  },
};
